module.exports = __webpack_public_path__ + "img/msfCoverArt.241cab0a.png";